import { Autocomplete, Box, TextField } from '@mui/material';
import { JobviewJob, JobViewSchoolRole } from 'types';

import { OptionTitle } from '../../../styles/hiringRequestStyles';
import { JobComboBoxProps } from '../../../types/hiringRequestTypes';
import SearchIcon from '@mui/icons-material/Search';

export const JobComboBox: React.FC<JobComboBoxProps> = ({
  onInputChange,
  options,
  isLoading,
  onChange,
  inputValue,
}) => {
  const handleRoleIdSelection = (value: JobviewJob | JobViewSchoolRole) => {
    onChange(value);
  };

  return (
    <Autocomplete
      freeSolo={inputValue?.length ? false : true}
      onChange={(_event, newValue) => {
        if (typeof newValue !== 'string') {
          handleRoleIdSelection(newValue);
        }
      }}
      onInputChange={(_e, value) => {
        onInputChange(value);
      }}
      options={options ? options : []}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.title)}
      loading={inputValue?.length > 0 ? isLoading : false}
      renderInput={(params) => (
        <TextField
          placeholder="Type or select job"
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: <SearchIcon sx={{ opacity: '30%' }} />,
          }}
          InputLabelProps={{
            shrink: false,
          }}
        />
      )}
      renderOption={(props, option) => (
        <Box {...props} component="li" key={option.id}>
          <OptionTitle>{option.title}</OptionTitle>
        </Box>
      )}
    />
  );
};
